<template>
  <div class="box-detail">
    <div class="box-left">
      <div class="box-left-header-contact">
        <div @click="$router.push({ path: '/Partners' })" class="goBack">
          <i class="el-icon-arrow-left"></i>
          <span>伙伴</span>
          <i class="el-icon-s-custom"></i>
        </div>
        <div class="profile-info">
          <el-image
            style="width: 72px; height: 72px; border-radius: 50%"
            src="https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg"
            fit="cover"
          ></el-image>
          <span>{{ formData.name }}</span>
          <ul class="shortcuts">
            <li>
              <el-tooltip
                class="item"
                effect="dark"
                content="打个电话"
                placement="top"
                :open-delay="300"
              >
                <a :href="'tel:' + formData.phone">
                  <el-button icon="el-icon-phone f-bold" circle></el-button>
                </a>
              </el-tooltip>
              <span>呼叫</span>
            </li>
            <li>
              <el-tooltip
                class="item"
                effect="dark"
                content="发送邮件"
                placement="top"
                :open-delay="300"
              >
                <a :href="'mailto:' + formData.email">
                  <el-button icon="el-icon-message f-bold" circle></el-button>
                </a>
              </el-tooltip>
              <span>邮件</span>
            </li>
            <li>
              <el-tooltip
                class="item"
                effect="dark"
                content="创建笔记"
                placement="top"
                :open-delay="300"
              >
                <el-button
                  icon="el-icon-edit-outline f-bold"
                  circle
                  @click="
                    activeTab = 'notes';
                    openNote = true;
                  "
                ></el-button>
              </el-tooltip>
              <span>笔记</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="box-left-content">
        <c-form
          :formData="formData"
          :fields="extFields"
          :options="options"
          ref="form"
          :upload="upload"
          labelWidth="100px"
          :area="area"
          @changeForm="osg.changeForm"
        >
          <!-- <template slot="description">
          <el-cascader
            v-model="formData.description"
            :options="treeDataOptions"
            :props="{
              value: '_id',
              label: 'orgName',
              children: 'orgList',
              checkStrictly: true
            }"
            :show-all-levels="false"
            props.checkStrictly="true"
          ></el-cascader>
        </template> -->
          <!-- <template slot="description">
          <el-form-item
            label="选择组织"
            prop="description"
            v-if="!isEdit"
            :rules="{
              required: true,
              trigger: 'blur',
              message: '所在组织不能为空'
            }"
          >
            <el-cascader
              v-model="formData.description"
              :options="treeDataOptions"
              :props="{
                value: '_id',
                label: 'orgName',
                children: 'orgList',
                checkStrictly: true
              }"
              :show-all-levels="false"
              props.checkStrictly="true"
            ></el-cascader>
          </el-form-item>
        </template> -->
          <!-- <el-form-item label="推广码" v-if="tenantId == '4551453470943235290'">
          <el-input v-model="formData.promoteCode"></el-input>
        </el-form-item> -->
          <!-- <el-form-item label="行业">
          <el-select v-model="formData.industry" clearable>
            <el-option
              v-for="item in options.industry"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item> -->
          <template slot="address">
            <el-input v-model="formData.address" @blur="getGeocode(formData.address)"></el-input>
          </template>
          <template slot="gpsPoint.longitude">
            <el-input
              v-model="formData.gpsPoint.longitude"
              disabled
              placeholder="根据地址自动生成"
            ></el-input>
          </template>
          <template slot="gpsPoint.latitude">
            <el-input
              v-model="formData.gpsPoint.latitude"
              disabled
              placeholder="根据地址自动生成"
            ></el-input>
          </template>
          <template slot="ownerId">
            <el-select
              v-model="formData.ownerId"
              filterable
              allow-create
              clearable
              placeholder="键入名称可搜索"
            >
              <el-option
                v-for="item in contactList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template slot="partnerType">
            <el-select v-model="formData.partnerType" clearable>
              <el-option
                v-for="item in options.partnerTypes"
                :key="item.value"
                :label="item.label"
                :value="Number(item.value)"
              ></el-option>
            </el-select>
          </template>
          <template slot="type">
            <el-select v-model="formData.type" clearable>
              <el-option
                v-for="item in options.partnerType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template slot="serviceType" v-if="tenantId == '1340835581184723420'">
            <el-select
              v-model="formData.serviceType"
              @change="serviceTypeChange"
              multiple
              clearable
            >
              <el-option
                v-for="item in options.serviceType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template slot="depositRatio">
            <!-- 支付比例字段 -->
            <template v-if="formData.exts.depositRatio">
              <el-form-item
                v-for="(val, key, index) in formData.exts.depositRatio"
                :key="index"
                v-model="formData.depositRatio"
                :label="osg.codelabel('serviceType', key)"
              >
                <div class="mo-input--number">
                  <el-input-number
                    :min="0"
                    :max="100"
                    type="number"
                    :controls="false"
                    v-model="formData.exts.depositRatio[key]"
                  >
                    <!-- <i slot="suffix" style="font-style:normal;margin-right: 10px;">%</i> -->
                  </el-input-number>
                  <div class="define-append">%</div>
                </div>
              </el-form-item>
            </template>
            <template v-else>
              请选择服务类型
            </template>
          </template>
          <!-- 是否开启支付比例字段 -->
          <template slot="isDepositRatio">
            <template v-if="formData.exts.isDepositRatio">
              <el-form-item
                v-for="(val, key, index) in formData.exts.isDepositRatio"
                :key="index"
                v-model="formData.isDepositRatio"
                :label="osg.codelabel('serviceType', key)"
              >
                <el-switch
                  v-model="formData.exts.isDepositRatio[key]"
                  active-text="是"
                  inactive-text="否"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </el-form-item>
            </template>
            <template v-else>
              请选择服务类型
            </template>
          </template>
        </c-form>
      </div>
      <div class="box-left-footer" v-if="osg.has('Partner,edit')">
        <el-button type="primary" @click="doSave">提交</el-button>
        <el-button plain @click="getData">取消</el-button>
      </div>
    </div>
    <!-- 动态 笔记 -->
    <div class="box-center">
      <el-tabs v-model="activeTab" class="c-h-1 c-flex c-flex-col">
        <el-tab-pane label="动态" name="log">
          <div class="box-center-tool">
            <div>
              <el-date-picker
                v-model="log.searchDate"
                type="datetimerange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss"
                clearable
                @change="getLog"
                class="search-date"
              ></el-date-picker>
            </div>
            <div>
              <el-input
                placeholder="请输入标题/内容"
                v-model="log.searchValue"
                class="search-input"
                clearable
                @clear="getLog"
                @keyup.enter.native="getLog"
              >
                <el-button slot="append" icon="el-icon-search" @click="getLog"></el-button>
              </el-input>
            </div>
          </div>
          <div class="box-center-content">
            <div class="activity-card" v-for="(log, i) in log.fpi.data" :key="i">
              <div class="activity-card-header">
                <span class="c-font-500">
                  <i class="el-icon-monitor c-w-30"></i>
                  {{ log.title }}
                </span>
                <span>{{ log.createTime }}</span>
              </div>
              <div class="activity-card-content">{{ log.content }}</div>
              <div class="activity-card-footer">
                <span>操作人：{{ log.createUserName }}</span>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="笔记" name="notes">
          <div class="box-center-tool">
            <div></div>
            <el-button
              type="primary"
              size="mini"
              @click="
                vqeditor.content = ``;
                openNote = true;
              "
            >
              创建笔记
            </el-button>
          </div>
          <div class="box-center-content">
            <div class="activity-card" v-for="(note, i) in noteData" :key="i">
              <div class="activity-card-header">
                <span>
                  <i class="el-icon-edit-outline c-w-30"></i>
                  笔记
                </span>
                <span>{{ note.createTime }}</span>
              </div>
              <div
                class="activity-card-content-node"
                v-html="note.content"
                @click="noteMdShow(note)"
                v-if="!note.openNote"
              ></div>
              <c-editor
                v-else
                class="c-m-15"
                :formData="note"
                :value="'content'"
                ref="editor"
              ></c-editor>
              <div class="activity-card-footer">
                <span>操作人：{{ note.createUserName }}</span>
              </div>
            </div>
          </div>
          <!-- markdown编辑器 -->
          <el-dialog title="笔记" :visible.sync="openNote">
            <c-editor :formData="vqeditor" :value="'content'" ref="editor"></c-editor>
            <div slot="footer">
              <el-button type="primary" @click="saveNote">确 认</el-button>
              <el-button
                @click="
                  openNote = false;
                  vqeditor.content = '';
                "
              >
                取 消
              </el-button>
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="属性变更记录" name="history">
          <div
            class="box-center-content"
            v-infinite-scroll="getHistory"
            :infinite-scroll-immediate="true"
          >
            <c-modify
              :historyFpi="historyFpi"
              :fields="extFields"
              :fieldsObj="fieldsObj"
              :options="options"
              ref="modify"
            ></c-modify>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="box-right" :class="collapse ? 'box-collapse' : ''">
      <div class="box-right-header">
        <i class="el-icon-d-arrow-left" @click="collapse = false" v-if="collapse"></i>
        <i class="el-icon-d-arrow-right" @click="collapse = true" v-else></i>
      </div>
      <div class="box-right-content" v-show="!collapse">
        <!-- <el-collapse>
          <el-collapse-item>
            <template slot="title">
              <span>服务资源</span>
              <el-button
                v-if="!ServiceResource.relatedData.length"
                type="text"
                icon="el-icon-plus"
                @click.stop="addServiceResource"
              >
                添加服务资源
              </el-button>
              <el-tooltip
                v-else
                class="item"
                effect="dark"
                content="1个伙伴只允许关联1个服务资源"
                placement="top-end"
              >
                <i class="el-icon-info c-color-primary"></i>
              </el-tooltip>
            </template>
            <div class="card-group">
              <div class="card-item" v-for="(item, i) of ServiceResource.relatedData" :key="i">
                <div>
                  <i class="el-icon-user-solid card-item-logo"></i>
                </div>
                <div>
                  <p>
                    <el-link :href="'/ServiceResource/' + item._id" target="_blank">
                      资源名称：{{ item.name }}
                    </el-link>
                  </p>
                  <p>伙伴名称：{{ item.relatedName }}</p>
                  <p>资源类型：伙伴</p>
                  <p>当前位置：{{ item.lastKnownLocation }}</p>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse> -->
        <el-collapse>
          <el-collapse-item>
            <template slot="title">
              <span>人员列表</span>
              <el-button
                type="text"
                icon="el-icon-plus"
                @click="$router.push({ path: '/OrgUser' })"
              >
                去添加
              </el-button>
            </template>
            <div class="card-group">
              <div class="card-item" v-for="(item, i) of userList.relatedData" :key="i">
                <div>
                  <i class="el-icon-user-solid card-item-logo"></i>
                </div>
                <div>
                  <p>{{ item.name }}</p>
                  <p>
                    <el-link :href="'tel:' + item.phone" target="_blank">
                      <i class="el-icon-phone-outline"></i>
                      {{ item.phone }}
                    </el-link>
                  </p>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>

    <!-- <el-drawer
      custom-class="c-drawer"
      title="服务资源"
      :visible.sync="ServiceResource.openEdit"
      direction="rtl"
      :fetch-suggestions="querySearch"
    >
      <div class="el-drawer__content">
        <el-tabs v-model="ServiceResource.activeName" type="card">
          <el-tab-pane label="新建服务资源" name="create">
            <el-form
              :model="ServiceResource.formData"
              :rules="rules"
              label-width="70px"
              label-position="left"
              hide-required-asterisk:true
            >
              <el-form-item label="名称" prop="name">
                <el-input v-model="ServiceResource.formData.name"></el-input>
              </el-form-item>
              <el-form-item label="位置">
                <el-input
                  type="textarea"
                  v-model="ServiceResource.formData.lastKnownLocation"
                  @change="getGeocode"
                ></el-input>
              </el-form-item>
              <el-form-item label="位置更新时间" v-show="false">
                <el-input
                  v-model="ServiceResource.formData.lastKnownLocationDate"
                  disabled
                ></el-input>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="el-drawer__footer" v-if="ServiceResource.activeName == 'search'">
        <el-button
          type="primary"
          @click="
            doSaveServiceResource();
            initServiceResource();
          "
        >
          保存
        </el-button>
        <el-button
          plain
          @click="
            getData();
            initServiceResource();
          "
        >
          取消
        </el-button>
      </div>
      <div class="el-drawer__footer" v-if="ServiceResource.activeName == 'create'">
        <el-button type="primary" @click="doSaveServiceResource()">保存</el-button>
        <el-button plain @click="initServiceResource">取消</el-button>
      </div>
    </el-drawer> -->
  </div>
</template>
<script>
// import areajs from '../../resources/js/area.js';
export default {
  name: 'partner',
  data() {
    let that = this;
    return {
      id: null,
      tenantId: '',
      collapse: false,
      formData: { gpsPoint: {}, exts: {}, foundTime: '' },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      fieldsObj: {},
      fpi: {},
      options: {
        codecfg_partnerType: { codeId: 'partnerType' },
        codecfg_partnerTypes: { codeId: 'partnerTypes' },
        codecfg_industry: { codeId: 'INDUSTRY' }
      },
      rules: this.$util.rules,
      activeTab: 'log',
      // 日志
      log: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: []
      },
      historyFpi: {
        page: 1,
        rows: 0,
        data: [],
        busy: false
      },
      noteData: [],
      openNote: false,
      vqeditor: this.$util.vqeditor,
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      contactList: [],
      //全部组织
      treeDataOptions: [],
      //人员列表
      userList: {
        relatedData: [],
        openEdit: false,
        formData: {}
      },
      //服务资源
      ServiceResource: {
        relatedData: [],
        openEdit: false,
        formData: {},
        searchObj: {},
        activeName: 'create'
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      }
    };
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    }
  },
  beforeDestroy() {
    this.editor = null;
    delete this.editor;
  },
  mounted() {
    window.$this = this;
    this.id = this.osg.param('id');

    let acount = JSON.parse(sessionStorage['loginAccount']);
    this.tenantId = acount.tenantId;

    this.osg.getFields('partner', () => {
      this.getData();
    });
    this.getLog();
    this.getNote();
    this.getContact();
  },
  methods: {
    getContact() {
      var params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 50,
        sortField: 'createTime',
        sortOrder: 'desc'
      };

      this.osg.ajax(
        'basic/contacts/query.do',
        params,
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.contactList = res.data;
          this.$forceUpdate();
        },
        { noload: true }
      );
    },
    //上传头像图片文件转base64
    getFileToBase64(file, fileList) {
      var that = this;
      const isJPG = file.raw.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.osg.toast('上传头像图片只能是 JPG 格式！', 'error');
        return;
      }
      if (!isLt2M) {
        this.osg.toast('上传头像图片大小不能超过 2MB！', 'error');
        return;
      }
      this.$util.Base64.imgFile(file.raw).then(res => {
        if (res) {
          that.formData.avatar = res;
          that.$forceUpdate();
        } else {
          this.osg.toast('上传失败', 'error');
        }
      });
    },
    getData() {
      let row;
      this.osg.ajax(`basic/partner/queryById/${this.id}.do`, {}, res => {
        row = this.$util.deepCopy(res);
        if (row.exts) {
          for (let key in row.exts) {
            if (this.$util.isJson(row.exts[key])) {
              row.exts[key] = JSON.parse(row.exts[key]);
            }
          }
        }
        // row.description = [row.description];
        this.$util.renderExtField(this.extFields, row);
        row.gpsPoint = row.gpsPoint || {};
        this.formData = row;
        //获取属性修改记录
        this.getHistory();
        this.getServiceResource(row);
        this.getUserList();
        this.getOrg();
      });
    },
    doSave() {
      if (this.osg.validate()) {
        this.$util.saveFormatExtField(this.extFields, this.formData);
        let params = this.formData;
        params.area = params.area || [];
        if (params.area.length > 0) {
          params.province = params.area[0] || '';
          if (params.area.length > 1) {
            params.city = params.area[1] || '';
            if (params.area.length > 2) {
              params.district = params.area[2] || '';
              if (params.area.length > 3) {
                params.subdistrict = params.area[3] || '';
              }
            }
          }
        }
        this.osg.ajax(
          'basic/partner/upsert.do',
          { partnerStr: JSON.stringify(this.formData) },
          res => {
            this.getData();
            this.osg.toast('保存成功！');
          }
        );
      }
    },
    getLog() {
      this.log.searchDate = this.log.searchDate || [];
      this.osg.ajax(
        'tenantLog/query.do',
        {
          sid: this.id,
          smodule: 'partner',
          _all: '1',
          'regex:title|string#or': this.log.searchValue,
          'regex:content|string#or': this.log.searchValue,
          'gte:createTime|datetime#and': this.log.searchDate[0],
          'lte:createTime|datetime#and': this.log.searchDate[1],
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.log.fpi = res;
        },
        { noload: true }
      );
    },
    getHistory() {
      // 其他getFields查询会更新掉表单的fieldsObj
      let fieldsObj = {};
      this.extFields.map(item => {
        if (item.showList && item.showList.indexOf('6') != -1) {
          item.label = item.nameDisp;
          item.value = item.name;
          fieldsObj[item.name] = item;
        }
      });
      this.fieldsObj = fieldsObj;
      this.osg.ajax(
        'biz/changeLog/query.do',
        {
          sid: this.id,
          page: this.historyFpi.page,
          rows: (this.historyFpi.rows += 10)
        },
        res => {
          if (res.data.length > 0) {
            // 不需要展示变更的字段名
            res.data = res.data.filter(item => {
              item.modifyList = item.modifyList.filter(obj => {
                return (
                  this.fieldsObj[obj.field] && this.fieldsObj[obj.field].showList.indexOf('6') != -1
                );
              });
              return item.modifyList.length > 0;
            });
            this.historyFpi = res;
          }
        },
        { noload: true }
      );
    },
    formatField(row, column, cellValue) {
      return this.osg.codelabel('fields', cellValue);
    },
    formatFieldValue(row, column, cellValue) {
      if (this.options[row.field]) {
        return this.osg.codelabel(row.field, cellValue);
      } else {
        return cellValue;
      }
    },
    getNote() {
      this.osg.ajax(
        'note/query.do',
        {
          sid: this.id,
          smodule: 'partner'
        },
        res => {
          this.noteData = res || [];
        }
      );
    },
    //保存笔记
    saveNote() {
      var params = {
        //sid，smodul，content，id，isDelete(值Y) 保存传123,修改传1234,删除传12345
        sid: this.id,
        smodule: 'partner',
        content: this.vqeditor.content
      };
      this.osg.ajax('note/upsert.do', params, res => {
        this.osg.toast('保存成功！');
        this.openNote = false;
        this.getNote();
      });
    },
    noteMdShow(note) {
      note.openNote = true;
    },
    //根据网址 提示域名下拉框
    querySearch(queryString, cb) {
      let url = this.formData.website;
      let reg = /^((https|http|ftp|rtsp|mms){0,1}(:\/\/){0,1})www\.(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/])+$/;
      if (reg.test(url)) {
        if (url.indexOf('www.') != -1) {
          url = url.substr(url.indexOf('.') + 1);
        } else if (url.indexOf('http://') != -1) {
          url = url.substr(url.indexOf('/', url.indexOf('/') + 1) + 1);
        } else if (url.indexOf('https://') != -1) {
          url = url.substr(url.indexOf('/', url.indexOf('/') + 1) + 1);
          if (url.indexOf('https://www.') != -1) {
            url = url.substr(url.indexOf('.') + 1);
          }
        }
        // 调用 callback 返回建议列表的数据
        cb([{ label: url, value: url }]);
      } else {
        cb([{}]);
      }
    },
    //获取人员列表
    getUserList() {
      let params = {
        'regex:orgIds|string#and': this.formData.orgId
      };
      this.osg.ajax('user/query.do', params, res => {
        if (res) {
          this.userList.relatedData = res.data;
        }
      });
    },
    //服务资源
    getServiceResource(row) {
      return new Promise(resolve => {
        this.osg.ajax(
          'biz/serviceResource/query.do',
          {
            'in:state|array-integer#and': '0,1',
            'is:serviceCrewId|string#and': row.orgId
          },
          res => {
            if (res.data) {
              this.ServiceResource.relatedData = res.data;
              // .filter(
              //   item => item.serviceCrewId == this.formData.orgId
              // );
              this.ServiceResource.data = res.data;
              resolve();
            }
          }
        );
      });
    },
    //新增服务资源
    addServiceResource() {
      this.ServiceResource.formData = {};
      this.ServiceResource.openEdit = true;
    },
    //删除服务资源
    removeServiceResource(removeResourcesId) {
      return new Promise(resolve => {
        this.osg.ajax(`biz/serviceResource/remove/${removeResourcesId}.do`, null, res => {
          resolve();
        });
      });
    },
    //保存服务资源
    doSaveServiceResource() {
      if (this.osg.validate()) {
        if (this.ServiceResource.relatedData.length) {
          let removeResourcesId = this.ServiceResource.relatedData[0]._id;
          this.removeServiceResource(removeResourcesId).then(() => {
            this.doSaveResource();
          });
        } else {
          this.doSaveResource();
        }
      } else {
        this.osg.toast('左侧表单，请完善必填项', 'error');
      }
    },
    doSaveResource() {
      let params = this.$util.deepCopy(this.ServiceResource.formData);
      this.$util.saveExtField(this.extFields, params);
      //保存经纬度
      params['gpsPoint.longitude'] = params.gpsPoint && params.gpsPoint.longitude;
      params['gpsPoint.latitude'] = params.gpsPoint && params.gpsPoint.latitude;
      delete params.gpsPoint;
      params.resourceType = 'partner';
      params.serviceCrewId = this.formData.orgId;
      params.relatedName = this.formData.name;
      this.osg.ajax('biz/serviceResource/upsert.do', params, res => {
        this.getData();
        this.initServiceResource();
        this.osg.toast('保存成功！');
      });
    },
    initServiceResource() {
      this.ServiceResource.openEdit = false;
      this.ServiceResource.formData = { exts: {}, gpsPoint: {} };
      this.$util.renderExtField(this.extFields, this.ServiceResource.formData);
    },
    //获取用户
    getUser(query) {
      let params = {
        page: 1,
        rows: 20,
        tenantId: this.tenantId,
        'regex:name|string#or': query
      };
      this.osg.ajax('user/query.do', params, res => {
        res.data.map(item => {
          item.label = item.name;
          item.value = item._id;
        });
        this.options.user = res.data;
      });
    },
    //获取地理编码
    async getGeocode(address) {
      if (!address) {
        this.formData.gpsPoint = {};
        this.formData.exts.citycode = '';
        this.formData.exts.address = '';
        return;
      }
      let str = '';
      if (this.$refs.form.$refs.area && this.$refs.form.$refs.area[0].getCheckedNodes()[0]) {
        let arr = this.$refs.form.$refs.area[0].getCheckedNodes()[0].pathLabels;
        if (arr && arr.constructor == Array) {
          for (let item of arr) {
            str += item;
          }
        }
      }
      this.formData.exts.address = str + address;
      this.osg.geocode(str + address, res => {
        if (!res) {
          this.formData.gpsPoint = {};
          this.formData.exts.citycode = '';
          return;
        }
        this.formData.gpsPoint = {
          longitude: res.location.split(',')[0],
          latitude: res.location.split(',')[1]
        };
        this.formData.exts.citycode = res.citycode;
        this.$forceUpdate();
      });
    },
    editServiceResource(item) {
      this.ServiceResource.formData = this.$util.deepCopy(item);
      this.ServiceResource.openEdit = true;
    },
    //获取组织
    getOrg() {
      return new Promise(resolve => {
        this.osg.ajax('org/query.do', {}, res => {
          if (res.data) {
            let data = [res.data];
            this.treeData = data;
            this.treeDataOptions = this.removeEmpty(
              res.data && res.data.orgList ? res.data.orgList : []
            );
            // console.log(this.treeDataOptions);
            // this.formData.description = !res.data._id ? "" : res.data._id;
            resolve();
          }
        });
      });
    },
    //删除空数组并且扁平化
    removeEmpty(arr) {
      if (Array.isArray(arr)) {
        arr.forEach(item => {
          if (item.orgList ? item.orgList.length === 0 : false) {
            delete item.orgList;
          } else {
            this.removeEmpty(item.orgList);
          }
        });
        return arr;
      }
    },
    renderCompute(formula) {
      return eval(formula);
    },
    serviceTypeChange(serviceType) {
      // 防水维修
      if (serviceType.indexOf('8191527117502723955') != -1) {
        if (!this.formData.exts.contractTyp || this.formData.exts.contractTyp.length == 0) {
          let contractTyp = this.options.contractType.map(item => item.value);
          this.$set(this.formData.exts, 'contractTyp', contractTyp);
        }
        if (!this.formData.exts.warrantyType || this.formData.exts.warrantyType.length == 0) {
          let warrantyType = this.options.warrantyType.map(item => item.value);
          this.$set(this.formData.exts, 'warrantyType', warrantyType);
        }
        if (
          !this.formData.exts.depositRatio ||
          !this.formData.exts.depositRatio['8191527117502723955']
        ) {
          if (!this.formData.exts.depositRatio) {
            this.$set(this.formData.exts, 'depositRatio', {});
          }
          this.$set(this.formData.exts.depositRatio, '8191527117502723955', '0');
        }
        if (
          !this.formData.exts.isDepositRatio ||
          !this.formData.exts.isDepositRatio['8191527117502723955']
        ) {
          if (!this.formData.exts.isDepositRatio) {
            this.$set(this.formData.exts, 'isDepositRatio', {});
          }
          this.$set(this.formData.exts.isDepositRatio, '8191527117502723955', '1');
        }
      } else {
        this.$set(this.formData.exts, 'contractTyp', []);
        this.$set(this.formData.exts, 'warrantyType', []);
        if (typeof this.formData.exts.depositRatio != 'undefined') {
          delete this.formData.exts.depositRatio['8191527117502723955'];
        }
        if (typeof this.formData.exts.isDepositRatio != 'undefined') {
          delete this.formData.exts.isDepositRatio['8191527117502723955'];
        }
      }
      // 防水施工
      if (serviceType.indexOf('20151276423303110') != -1) {
        if (
          !this.formData.exts.fssgContractType ||
          this.formData.exts.fssgContractType.length == 0
        ) {
          let fssgContractType = this.options.fssgContractType.map(item => item.value);
          this.$set(this.formData.exts, 'fssgContractType', fssgContractType);
        }
        if (
          !this.formData.exts.fssgWarrantyType ||
          this.formData.exts.fssgWarrantyType.length == 0
        ) {
          let fssgWarrantyType = this.options.fssgWarrantyType.map(item => item.value);
          this.$set(this.formData.exts, 'fssgWarrantyType', fssgWarrantyType);
        }
        if (
          !this.formData.exts.depositRatio ||
          !this.formData.exts.depositRatio['20151276423303110']
        ) {
          if (!this.formData.exts.depositRatio) {
            this.$set(this.formData.exts, 'depositRatio', {});
          }
          this.$set(this.formData.exts.depositRatio, '20151276423303110', '0');
        }
        // 是否开启支付比例
        if (
          !this.formData.exts.isDepositRatio ||
          !this.formData.exts.isDepositRatio['20151276423303110']
        ) {
          if (!this.formData.exts.isDepositRatio) {
            this.$set(this.formData.exts, 'isDepositRatio', {});
          }
          this.$set(this.formData.exts.isDepositRatio, '20151276423303110', '1');
        }
      } else {
        this.$set(this.formData.exts, 'fssgContractType', []);
        this.$set(this.formData.exts, 'fssgWarrantyType', []);
        if (typeof this.formData.exts.depositRatio != 'undefined') {
          delete this.formData.exts.depositRatio['20151276423303110'];
        }
        if (typeof this.formData.exts.isDepositRatio != 'undefined') {
          delete this.formData.exts.isDepositRatio['20151276423303110'];
        }
      }
      // 美缝
      if (serviceType.indexOf('7479703534058845803') != -1) {
        if (!this.formData.exts.mfContractType || this.formData.exts.mfContractType.length == 0) {
          let mfContractType = this.options.mfContractType.map(item => item.value);
          this.$set(this.formData.exts, 'mfContractType', mfContractType);
        }
        if (!this.formData.exts.mfWarrantyType || this.formData.exts.mfWarrantyType.length == 0) {
          let mfWarrantyType = this.options.mfWarrantyType.map(item => item.value);
          this.$set(this.formData.exts, 'mfWarrantyType', mfWarrantyType);
        }
        if (
          !this.formData.exts.depositRatio ||
          !this.formData.exts.depositRatio['7479703534058845803']
        ) {
          if (!this.formData.exts.depositRatio) {
            this.$set(this.formData.exts, 'depositRatio', {});
          }
          this.$set(this.formData.exts.depositRatio, '7479703534058845803', '0');
        }

        // 是否开启支付比例
        if (
          !this.formData.exts.isDepositRatio ||
          !this.formData.exts.isDepositRatio['7479703534058845803']
        ) {
          if (!this.formData.exts.isDepositRatio) {
            this.$set(this.formData.exts, 'isDepositRatio', {});
          }
          this.$set(this.formData.exts.isDepositRatio, '7479703534058845803', '1');
        }
      } else {
        this.$set(this.formData.exts, 'mfContractType', []);
        this.$set(this.formData.exts, 'mfWarrantyType', []);
        delete this.formData.exts.depositRatio['7479703534058845803'];
        delete this.formData.exts.isDepositRatio['7479703534058845803'];
      }
    }
  }
};
</script>
<style lang="scss" scoped>
/*个人信息*/
.box-left-header-contact {
  border-bottom: 1px solid #dfe3eb;
}
.profile-info {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.profile-info > * {
  margin: 10px auto;
}
.profile-info > span {
  margin: 0;
  font-weight: 400;
  font-size: 24px;
}
.profile-info ul {
  display: flex;
}
.profile-info ul li {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 5px;
}
.profile-info ul li span {
  margin-top: 8px;
  font-size: 12px;
}
/* 快捷按钮 */
.shortcuts button {
  background-color: #eaf0f6;
  border-color: #cbd6e2;
  color: #506e91;
}
.shortcuts button i {
  font-weight: bold;
}
</style>
